// extracted by mini-css-extract-plugin
export default {"eventJoined":"Event_eventJoined__lwJ1O","eventImage":"Event_eventImage__6j-TR"};